import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface sectionIdState {
  sectionId: string;
  sectionIndex?: number; // optional property
}

const initialState: sectionIdState = {
  sectionId: '',
  sectionIndex: 0, // initialize to undefined
};

const sectionIdSlice = createSlice({
  name: 'sectionId', // better to use lowercase for the name
  initialState,
  reducers: {
    setSectionId: (state, action: PayloadAction<string>) => {
      state.sectionId = action.payload;
    },
    setSectionIndex: (state, action: PayloadAction<number>) => {
      state.sectionIndex = action.payload; // update sectionIndex
    },
  },
});

export const { setSectionId, setSectionIndex } = sectionIdSlice.actions;
export default sectionIdSlice.reducer;
